/* Publish by EComposer at 2026-09-30 16:29:02*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-g52wxscgf8"]=  window.__ectimmers["ecom-g52wxscgf8"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-g52wxscgf8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g52wxscgf8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hu34dtrn2g9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hu34dtrn2g9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzf37x5zzi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzf37x5zzi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y8qknicupja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y8qknicupja', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-itnkgq2ek7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-itnkgq2ek7c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j7hehambzle').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j7hehambzle', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lxw5frk1r0d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lxw5frk1r0d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-euoyperdu67').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-euoyperdu67', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s1c2nf7qsvr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s1c2nf7qsvr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j0vmraf5p1d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j0vmraf5p1d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zrena7vsnk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zrena7vsnk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qhc186xg8u8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qhc186xg8u8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jx6dhj2z0ce').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jx6dhj2z0ce', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ugzvnqiny').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ugzvnqiny', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eo8us59ogw5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eo8us59ogw5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f8229261xt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f8229261xt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ovhbcw1ieq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ovhbcw1ieq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wj278vup8vi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wj278vup8vi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qgru463u5me').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qgru463u5me', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8a7sdbj39et').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8a7sdbj39et', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h6a8whz3ouj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h6a8whz3ouj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e6bz2pmo4j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e6bz2pmo4j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3s76u9ga9u8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3s76u9ga9u8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h1ml4d9okgc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h1ml4d9okgc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t30tsli73vm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t30tsli73vm', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gc1imx3vfd"]=  window.__ectimmers["ecom-gc1imx3vfd"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-gc1imx3vfd"]["6ml5m9mpv"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-gc1imx3vfd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gc1imx3vfd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pi9uprvspff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pi9uprvspff', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k8d7dqf7giq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k8d7dqf7giq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-objjkiqd3s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-objjkiqd3s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hsutv2ymk55').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hsutv2ymk55', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b4zmuiuv6jg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b4zmuiuv6jg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3hjpgf3z773').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3hjpgf3z773', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0q37s6tqdr8d"]=  window.__ectimmers["ecom-0q37s6tqdr8d"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-0q37s6tqdr8d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0q37s6tqdr8d', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mamh6mhsryk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mamh6mhsryk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7hncwlznjwt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7hncwlznjwt', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-22pa8f7jt5pj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-22pa8f7jt5pj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-733hiozpc4e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-733hiozpc4e', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-128aau2ah25').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-128aau2ah25', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i9kuowfrjm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i9kuowfrjm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ymezidr1cr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ymezidr1cr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}